import en from './resources/en.json'
import pl from './resources/pl.json'

/**
 * Struktura namespace'u "common" — źródłem prawdy dla kluczy jest
 * `resources/pl.json`. Warstwa web może użyć tego typu w deklaracji
 * `CustomTypeOptions` i18next, żeby mieć type-safe klucze `t()`.
 */
export type CommonNamespace = typeof pl

/** Języki wspierane przez aplikację; polski jest domyślny i fallbackowy. */
export type AppLanguage = 'pl' | 'en'

/** Komplet zasobów w układzie i18next: język → namespace → klucze. */
export const resources = {
  pl: { common: pl },
  en: { common: en },
} satisfies Record<AppLanguage, { common: CommonNamespace }>
